<!--  -->
<template>
  <div>
    <div style="margin-bottom: 20px;">
      <el-input
        v-model="pageIfonone.keyword"
        style="width:200px;margin-right: 10px;"
        placeholder="请输入小程序名称/appid"
      />
      <el-select
        v-model="pageIfonone.mini_program_type"
        placeholder="请选择小程序类型"
        clearable
      >
        <el-option
          v-for="item in options"
          :key="item.mini_program_type"
          :label="item.type_name"
          :value="item.mini_program_type"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left:10px"
        @click="srarch"
      >搜索</el-button>
      <el-button
        type="info"
        icon="el-icon-refresh"
        style="margin-left:10px"
        @click="reastr"
      >重置</el-button>
    </div>

    <el-table
      ref="multipleTable"
      tooltip-effect="dark"
      :data="tableData"
      border
      style="width: 100%"
      :row-key="rowKey"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55"
      />

      <el-table-column
        prop="app_id"
        label="小程序appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="小程序名称"
        align="center"
        width="180"
      />
      <el-table-column
        prop="user_version"
        label="版本号"
        align="center"
        width="180"
      />
      <el-table-column
        prop="operation_status_text"
        label="状态"
        align="center"
      />
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div>
      <el-button
        type="primary"
        @click="quedaw"
      >确定</el-button>
    </div>
    <el-dialog
      title="绑定公众号失败列表"
      :visible.sync="erroraccount"
      width="60%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <errorlist ref="errorlistview" />
    </el-dialog>
  </div>
</template>

<script>
import { appletlistrw, goexperience, mptypeslist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import errorlist from '../../redEnvelopeActivity/components/errorlist.vue'
export default {
  components: {
    PaginationRight,
    errorlist
  },
  data() {
    return {
      pageIfonone: {
        page: 1,
        page_size: 10,
        mini_program_type: '',
        keyword: ''
      },
      tableData: [],
      multipleSelection: [],
      total: null,
      obj: {},
      erroraccount: false,
      options: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    rowKey(row) {
      return row.id
    },
    send(item) {
      this.obj = item
      this.getprogramlist()
      this.getapplettype()
    },
    async getapplettype() {
      const data = await mptypeslist()
      this.options = data.data.types
      console.log('data', data)
    },
    // 获取绑定列表
    async getprogramlist() {
      const data = await appletlistrw(this.pageIfonone)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfonone.pageSize = e
      this.getprogramlist()
    },
    fetchCurrentPage(e) {
      this.pageIfonone.page = e
      this.getprogramlist()
    },
    chooser(row) {
      console.log('row', row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('this.multipleSelection', this.multipleSelection)
    },
    async quedaw() {
      // eslint-disable-next-line eqeqeq
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: 'error',
          message: '请选择小程序'
        })
        return
      }
      const arrid = this.multipleSelection.map(item => {
        return item.app_id
      })
      console.log(this.obj, arrid)
      const data = await goexperience({
        id: this.obj.id,
        user_version: this.obj.userVersion,
        user_desc: this.obj.userDesc,
        extAppids: arrid
      })
      console.log(data.data.fail.length)
      // eslint-disable-next-line eqeqeq
      if (data.data.fail.length != 0) {
        this.$emit('callback', data.data.fail)
      } else {
        this.$message({
          type: 'success',
          message: '创建成功'
        })
        this.$emit('callback', [])
      }

      // this.$emit('callback')
      /*      this.$emit('callback') */
    },
    srarch() {
      this.pageIfonone.page = 1
      this.getprogramlist()
    },
    reastr() {
      this.pageIfonone.page = 1
      this.pageIfonone.keyword = ''
      this.pageIfonone.mini_program_type = ''
      this.getprogramlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
